import axios from "axios";
import { toast } from "react-toastify";

//pass new generated access token here

//apply base url for axios
const API_URL = "https://nzm7rnqk-5001.inc1.devtunnels.ms";

const axiosApi = axios.create({
  baseURL: API_URL,
  withCredentials: false,
});
const data = localStorage.getItem("authUser");
const parseData = JSON.parse(data);
const token = parseData?.token;

// axiosApi.defaults.headers.common["Authorization"] = "Bearer " + token;
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  try {
    const response = await axiosApi.get(url, {
      ...config,
      headers: {
        ...(config.headers || {}),
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
      params: {
        ...(config.params || {}),
        _ts: Date.now(), // ✅ cache-buster query param
      },
    });

    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
    throw error; // ✅ rethrow so callers know it failed if needed
  }
}

export async function postWithFormData(url, data, config = {}) {
  // console.log("from the post--->", data);
  return axiosApi
    .post(url, data, { ...config })
    .then((response) => response.data)
    .catch((error) => {
      toast.error(error?.response?.data?.message);
    });
}
export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, data, { ...config })
    .then((response) => response.data)
    .catch((error) => {
      toast.error(error?.response?.data?.message);
      return Promise.reject(error); // Propagate the error
    });
}

export async function putWithFormData(url, data, config = {}) {
  return axiosApi
    .put(url, data, { ...config })
    .then((response) => response.data)
    .catch((error) => {
      toast.error(error?.response?.data?.message);
    });
}
export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data)
    .catch((error) => {
      toast.error(error?.response?.data?.message);
    });
}

export async function del(url, config = {}) {
  console.log("from the del --->", url);
  try {
    const response = await axiosApi.delete(url, config);
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Delete failed");
    throw error;
  }
}
